import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const WWW_HOST = "www.test-alberta-class7.vercel.app";
const CANONICAL_HOST = "test-alberta-vercel.app";

function NotFoundPage() {
  useEffect(() => {
    const { hostname, pathname, search, hash } = window.location;

    if (hostname === WWW_HOST) {
      const redirectUrl = `https://${CANONICAL_HOST}${pathname}${search}${hash}`;
      window.location.replace(redirectUrl);
    }
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: "12px",
        padding: "24px",
        textAlign: "center",
      }}
    >
      <h1 style={{ margin: 0 }}>404 - Page Not Found</h1>
      <p style={{ margin: 0 }}>The page you are looking for does not exist.</p>
      <Link to="/">Go back to Home</Link>
    </div>
  );
}

export default NotFoundPage;